import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { DepartmentInfo } from '../../model/department.model';


@Component({
  selector: 'app-Department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;
  _PositionModule: number;

  LoadDepartment: DepartmentInfo[];
  txtSchDepartmentName: string;
  txtSchDepartmentCode: string;
  ddlSchPositionStatus: string;
  txtDepartmentCode: string;
  txtDepartmentName: string;
  isOnUpdate: boolean;
  hidDepartmentId: number;
  element: HTMLElement;
  public hidcouchk: string;
  IsDuplicateCode: boolean = false;
  IsSubmitted: boolean = false;
  totalDepartments: number;

  //Form variable
  positionForm: FormGroup;
  positionInfo: DepartmentInfo = new DepartmentInfo;

  //Pagination
  currentPageNumber: number = 1;
  totalPositions: number = 0;
  totalPages: number = 0;
  pageSize: number;
  public DepartmentTotal: any
  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;

  // Zone pagination variable
  isSubmitted: any;
  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeSmall;
    this._EmpCode = localStorage.getItem("EmpCode");
    this._PositionModule = ConstVariable.PositionProjectModule; //Project Delivery
    this.ddlSchPositionStatus = ''
    this.LDepartment();
    //$(document).ready(function () {
    //  $('#InsertSectionDepartment').css('display', 'none');
    //});

    //Load init data




    //Declare form
    this.positionForm = new FormGroup({
      //PositionCode: new FormControl(this.positionInfo.PositionCode, [Validators.required]),
      //PositionName: new FormControl(this.positionInfo.PositionName, [Validators.required]),
      //PositionLevel: new FormControl(this.positionInfo.PositionLevel, [Validators.required]),
      //PositionStatus: new FormControl(this.positionInfo.FlagActive),
      //FlagCreate: new FormControl(this.positionInfo.FlagCreate),
      //FlagEdit: new FormControl(this.positionInfo.FlagEdit),
      //FlagDeleteRights: new FormControl(this.positionInfo.FlagDeleteRights),
      //FlagApprove: new FormControl(this.positionInfo.FlagApprove),
      //FlagAssign: new FormControl(this.positionInfo.FlagAssign),
      //FlagView: new FormControl(this.positionInfo.FlagView),
    });
  }

  //get PositionCode() { return this.positionForm.get('PositionCode'); }
  //get PositionName() { return this.positionForm.get('PositionName'); }
  //get PositionLevel() { return this.positionForm.get('PositionLevel'); }


  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  LDepartment() {
    this.LoadListDepartment()
      .then(
        data => {
          this.LoadDepartment = data
        }
      )
      .then(() => {
        this.CountDepartmentList()
      })
  }

  async CountDepartmentList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['DepartmentName'] = this.checkUndefinedString(this.txtSchDepartmentName);
      objectjson['DepartmentCode'] = this.checkUndefinedString(this.txtSchDepartmentCode);
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);


      this.httpClient
        .post<number>(this.baseurl + "Department/GetCountDepartment",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.SetTotalpagePagination(data);
        });
    }
  }


  async LoadListDepartment(positionId: number = 0): Promise<DepartmentInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['DepartmentName'] = this.checkUndefinedString(this.txtSchDepartmentName);
      objectjson['DepartmentCode'] = this.checkUndefinedString(this.txtSchDepartmentCode);
      
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<DepartmentInfo[]>(this.baseurl + "Department/GetDepartment", strjson, httpOptions)
        .toPromise()

    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.LoadListDepartment().then((data) => {
      this.LoadDepartment = data;
    });
  }
  OnClear_Click() {
    this.txtSchDepartmentName = null;
    this.txtSchDepartmentCode = null;
    this.txtDepartmentName = null;
    this.txtDepartmentCode = null; 

    this.currentPageNumber = 1;
    this.LoadListDepartment().then((data) => {
      this.LoadDepartment = data;
    });
  }

  
  //Create btn
  btnClick_onCreateDepartment() {
    this.txtDepartmentCode = "";
    this.txtDepartmentName = "";
    this.isOnUpdate = false;
    this.IsSubmitted = false;
    //$('#InsertSectionDepartment').css('display', 'block');
    $('#modalCreateOrEditDepartment').modal();
  }
  btnClick_cancel() {
    this.txtSchDepartmentName = null;
    this.txtSchDepartmentCode = null;
    this.txtDepartmentName = null;
    this.txtDepartmentCode = null;
    //$('#InsertSectionDepartment').css('display', 'none');
    $('#modalCreateOrEditDepartment').modal('hide');
  }


  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitlookup").hide();
      $("#txtLookupType").prop('disabled', true);
      $("#txtLookupValue").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitlookup").show();
      $("#txtLookupType").removeAttr('disabled');
      $("#txtLookupValue").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalLookup').modal('hide');
    }
  }


  async btnClick_submitInsertDepartment() {
    this.IsSubmitted = true;

    if (!this.txtDepartmentCode)
      return;

    if (!this.txtDepartmentName)
      return;

    if (this.IsDuplicateCode)
      return;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.OnCreating('y');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };



      let strjson = "{" +
        "\"DepartmentCode\": \"" + this.checkUndefinedString(this.txtDepartmentCode) + "\", " +
        "\"DepartmentName\": \"" + this.checkUndefinedString(this.txtDepartmentName) + "\", " +
        "\"CreateBy\": \"" + this.checkUndefinedString(localStorage.getItem("EmpCode")) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";

      this.isSubmitted = this.httpClient.post<LookupInfo[]>(this.baseurl + "Department/InsertDepartment", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
          this.OnCreating('n');
        },
          () => {
            console.log("Insert = " + this.isSubmitted)
            this.OnClear_Click();
            //this.AuthorizeUser(this.ddlCompany + "0" + this.txtExEmpCode);

            //Inform user
            this.titlemodal = '';
            this.detailmodal = 'Department has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            /*$('#InsertSectionDepartment').css('display', 'none');*/
            $('#modalCreateOrEditDepartment').modal('hide');
            this.LDepartment()
          }
        );
    }
  }

  //Edit Function
  OnEdit_Click(id) {
    
    //document.getElementById("AddEditDepartment").scrollIntoView();
    this.isOnUpdate = true


    let index = this.LoadDepartment.findIndex(x => x.DepartmentId == id);
    this.hidDepartmentId = this.LoadDepartment[index].DepartmentId
    this.txtDepartmentCode = this.LoadDepartment[index].DepartmentCode
    this.txtDepartmentName = this.LoadDepartment[index].DepartmentName
    $('#modalCreateOrEditDepartment').modal();
  }
  btnClick_submitUpdateDepartment(id) {
    this.IsSubmitted = false;
    $('#ModalConfirmChanges').modal();
  }
  async confirmSaveChanges() {
    this.IsSubmitted = true;

    if (!this.txtDepartmentCode)
      return;

    if (!this.txtDepartmentName)
      return;

    if (this.IsDuplicateCode)
      return;

    $('#ModalConfirmChanges').modal('hide');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      //$('#InsertSectionDepartment').css('display', 'block');
      var id = this.hidDepartmentId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      if (this.txtDepartmentName == undefined || this.txtDepartmentName == null || this.txtDepartmentName == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }

      else if (this.txtDepartmentCode == undefined || this.txtDepartmentCode == null || this.txtDepartmentCode == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }
      else {

        let objData = {};
        objData["DepartmentId"] = id;
        objData["DepartmentCode"] = this.txtDepartmentCode;
        objData["DepartmentName"] = this.txtDepartmentName;
        objData["UpdateBy"] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<DepartmentInfo[]>(this.baseurl + "Department/UpdatDepartment", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.OnClear_Click();
              //$('#InsertSectionDepartment').css('display', 'none');
              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditDepartment').modal('hide');
              //Load new data
              this.LDepartment();
            }
          )
      }
    }
  }


  //Delete Function
  async OnDelete_Click(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{DepartmentId: " + id + "}";

      if (confirm("Are you sure you want to delete this Department?")) {
        this.isSubmitted = this.httpClient.post<DepartmentInfo[]>(this.baseurl + "Department/DeleteDepartment", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.OnClear_Click();

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'Department information has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LDepartment();
            }
          )
      }
    }

  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxDepartment"]').prop('checked', check);

  }

  async OnDeleteList_Click() {
    let num = parseInt(this.hidcouchk);
    for (var i = 0; i < num; i++) {
      var element = <HTMLInputElement>document.getElementById('chk' + i);
      var isChecked = element.checked;

      var element2 = <HTMLInputElement>document.getElementById('DepartmentId' + i);

      if (isChecked) {
        await this.OnDelete_Click(parseInt(element.value));
      }
    }
    //Load new data
    this.LDepartment();
  }

  //Name position clicked
  OnAddRights_Click(id) {

  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
    }

    this.LoadListDepartment().then((data) => {
      this.LoadDepartment = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalPositions = data;
    if (this.totalPositions == 0) this.currentPageNumber = 0;
    this.totalPages = Math.ceil(this.totalPositions / environment.PageSize);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  async CheckDuplicateCode() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['DepartmentCode'] = this.txtDepartmentCode;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "Department/CheckDuplicateDepartmentCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }
}
